// extracted by mini-css-extract-plugin
module.exports = {"languageBtn":"LanguageBtn_languageBtn__3OABl","loginLanguageBtn":"LanguageBtn_loginLanguageBtn__1ONWt"};